import { componentsRegistryService } from "cruzo";
import { AbstractIcon } from "./abstract";

export class PlusIcon extends AbstractIcon {
  static selector = "plus-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
      </svg>`;
  }
}

componentsRegistryService.define(PlusIcon);
